import { Spiner } from "@components/loaders/spiner";
import {
  AuthLoginForm,
  authLoginFormSchema,
} from "@components/resolvers/auth.resolvers";
import { yupResolver } from "@hookform/resolvers/yup";
import { AuthService } from "@services/auth.service";
import { SchoolService } from "@services/school.service";
import { useNotificationStore } from "@stores/notification.store";
import { useSchoolStore } from "@stores/school.store";
import { useMutation } from "@tanstack/react-query";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { FaCheck, FaHashtag, FaLock, FaTimes, FaUser } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

export const LoginPage = () => {
  const navigate = useNavigate();
  const { pushNotification } = useNotificationStore((state) => state);
  const { updateInfo } = useSchoolStore((state) => state);
  const { register, handleSubmit } = useForm<AuthLoginForm>({
    resolver: yupResolver<AuthLoginForm>(authLoginFormSchema),
  });

  useEffect(() => {
    initValidate();
  }, []);

  const { mutate, isLoading } = useMutation(AuthService.login, {
    onSuccess: async (response) => {
      if (response.success) {
        onUpdateInfoSchool(response.data?.prefix ?? "");
        navigate(response.data!.redirect);
      } else {
        pushNotification({
          type: "error",
          message: response.message,
        });
      }
    },
    onError: (error: unknown) => {
      pushNotification({
        type: "error",
        message: error instanceof Error ? error.message : "Internal Error",
      });
    },
  });

  const onUpdateInfoSchool = async (prefix: string) => {
    const responseInfo = await SchoolService.info(prefix);
    updateInfo({
      name: responseInfo.data?.namaLembaga,
      moto: responseInfo.data?.motoLembaga,
      logo: responseInfo.data?.logoLembaga,
      prefix: responseInfo.data?.prefix,
    });
  };

  return (
    <div className="tw-min-h-[calc(100vh-655px)]">
      <div className="card card-style">
        <div className="content mt-2 mb-0">
          <form
            autoComplete="off"
            method="post"
            onSubmit={handleSubmit((data) =>
              mutate({
                username: `${data.prefix}${data.username}`,
                password: data.password,
              })
            )}
          >
            <div className="input-style no-borders has-icon validate-field mb-4">
              <i className="lh-1">
                <FaHashtag />
              </i>
              <input
                type="text"
                inputMode="numeric"
                maxLength={5}
                className="form-control"
                placeholder="Kode/Prefix"
                {...register("prefix")}
              />
              <label htmlFor="form0a" className="color-blue-dark font-10 mt-1">
                Kode (5 angka)
              </label>
              <i className="disabled invalid color-red-dark">
                <FaTimes />
              </i>
              <i className="disabled valid color-green-dark">
                <FaCheck />
              </i>
              <em>(*wajib)</em>
            </div>

            <div className="input-style no-borders has-icon validate-field mb-4">
              <i className="lh-1">
                <FaUser />
              </i>
              <input
                type="text"
                className="form-control"
                placeholder="Username"
                {...register("username")}
              />
              <label htmlFor="form1a" className="color-blue-dark font-10 mt-1">
                Username
              </label>
              <i className="disabled invalid color-red-dark">
                <FaTimes />
              </i>
              <i className="disabled valid color-green-dark">
                <FaCheck />
              </i>
              <em>(*wajib)</em>
            </div>

            <div className="input-style no-borders has-icon validate-field mb-4">
              <i className="lh-1">
                <FaLock />
              </i>
              <input
                type="password"
                className="form-control validate-password"
                placeholder="Password"
                {...register("password")}
              />
              <label htmlFor="form3a" className="color-blue-dark font-10 mt-1">
                Password
              </label>
              <i className="disabled invalid color-red-dark">
                <FaTimes />
              </i>
              <i className="disabled valid color-green-dark">
                <FaCheck />
              </i>
              <em>(*wajib)</em>
            </div>

            <button
              type="submit"
              className="btn btn-m mt-4 mb-3 btn-full tw-w-full bg-button-red-dark rounded-sm text-uppercase font-900"
            >
              {isLoading ? <Spiner /> : "Login"}
            </button>
          </form>

          <div className="text-center">
            <Link to={linkPage.AUTH_FORGOT_PASSWORD}>Lupa Password?</Link>
          </div>

          <div className="divider mt-4 mb-3"></div>

          {/* <p className="text-center tw-text-sm tw-font-light tw-text-gray-500 mb-4">
            Silahkan hubungi <span className="tw-font-medium tw-text-blue-700">Admin</span> jika terjadi masalah <br /> terhadap aplikasi
          </p> */}
        </div>
      </div>
    </div>
  );
};
